import React from "react";
import ApiSection from "./api-section/ApiSection";
import { MainSection } from "cdk-radial";
import { DirectoryTypeProvider } from "../../../contexts/DirectoryTypeContext";
import { APIDirectoryHomeContextProvider } from "../../../contexts/APIHomeDirectoryContext.js";
import "@fontsource/open-sans";
import "./api-directory.css";

const APIDirectoryHome = props => {
  const {
    auth,
    belongsTo,
    apis,
    apisLoading,
    apiBundles,
    asyncApis,
    asyncApisLoading,
    entity,
    domainsLoading,
    domains,
    cartDetails,
    apiHomeOnClickHandlers,
    selectedAPIType,
    selectedDomainIds,
    orderDetails,
    sendAmplitudeData,
    environmentURLs,
    existingSolutionDetails,
    disableBuildNow,
    bundleDetailsViewEnabled,
    requestStatus,
    selectedFilterType,
    isMsaConsented,
    fetchingDAABConsentDetails,
    requestingOrgId,
    isDealerPurchaseDisabled
  } = props;

  return (
    <DirectoryTypeProvider directoryType={belongsTo}>
      <APIDirectoryHomeContextProvider
        auth={auth}
        cartDetails={cartDetails}
        requestStatus={requestStatus}
        orderDetails={orderDetails}
        belongsTo={belongsTo}
        apiBundles={apiBundles}
        apiHomeOnClickHandlers={apiHomeOnClickHandlers}
      >
        <MainSection className="api-dir-pkg_main__section_page">
          <ApiSection
            auth={auth}
            apis={apis}
            apiBundles={apiBundles}
            apisLoading={apisLoading}
            asyncApis={asyncApis}
            asyncApisLoading={asyncApisLoading}
            domains={domains}
            domainsLoading={domainsLoading}
            entity={entity}
            belongsTo={belongsTo}
            cartDetails={cartDetails}
            apiHomeOnClickHandlers={apiHomeOnClickHandlers}
            selectedDomainIds={selectedDomainIds}
            selectedAPIType={selectedAPIType}
            orderDetails={orderDetails}
            sendAmplitudeData={sendAmplitudeData}
            environmentURLs={environmentURLs}
            existingSolutionDetails={existingSolutionDetails}
            disableBuildNow={disableBuildNow}
            bundleDetailsViewEnabled={bundleDetailsViewEnabled}
            requestStatus={requestStatus}
            selectedFilterType={selectedFilterType}
            isMsaConsented={isMsaConsented}
            fetchingDAABConsentDetails={fetchingDAABConsentDetails}
            requestingOrgId={requestingOrgId}
            isDealerPurchaseDisabled={isDealerPurchaseDisabled}
          />
        </MainSection>
      </APIDirectoryHomeContextProvider>
    </DirectoryTypeProvider>
  );
};
export default APIDirectoryHome;
